import { render, staticRenderFns } from "./OnboardingFinancialSettings.vue?vue&type=template&id=ef25dd7a&scoped=true"
import script from "./OnboardingFinancialSettings.vue?vue&type=script&lang=js"
export * from "./OnboardingFinancialSettings.vue?vue&type=script&lang=js"
import style0 from "./OnboardingFinancialSettings.vue?vue&type=style&index=0&id=ef25dd7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef25dd7a",
  null
  
)

export default component.exports